<template>
  <v-col cols="5">
    <v-card class="actions-card" v-on:click="handleButtonClick" >
      <v-card-actions class="text-center actions-btn red--text">
        <v-btn text class="red--text actions-btn-text"><v-img src="../../../../../assets/svg/withdraw.svg"></v-img>{{decideButtonText() }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog  v-model="dialog" width="480" >
      <v-card>
        <Loader :loading="loading" :message="message"/>
        <v-toolbar class="box"  @click.stop="dialog = false">
          <v-icon>mdi-close</v-icon>
          <v-toolbar-title>Close</v-toolbar-title>
        </v-toolbar>
        <div class="comment-content">
          <v-card-title class="comment-heading">Withdraw Application</v-card-title>
          <br/>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form v-if="!submitted" @submit.prevent="handleSubmit(withdrawApplicantApplication)">

          <div class="row">
            <v-textarea
                outlined
                name="input-7-4"
                row-height="15"
                label="Reason For Withdraw"
                v-model="reasonForWithdraw"
                auto-grow
                />

          </div>
          <div >
            <v-card-actions>
              <v-btn
                  color="red"
                  class="submit"
                  depressed
                  x-large
                  type="submit"
                  width="100%"
                  block
              >
                Submit
              </v-btn>

            </v-card-actions>
          </div>
            </form>
          </ValidationObserver>
        </div>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import Loader from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/Loader";
import axios from "axios";
import {rescindWithdrawApplicant, withdrawApplicant} from "@/services/ApiServices";
import {mapGetters} from "vuex";

export default {
  name: "WithdrawApplication",
  components: {
    Loader
  },
  data() {
    return {

      dialog: false,
      reasonForWithdraw: "",
      message: "Loading",
      loading: false,
      submitted: false

    }

  },


  methods: {
    handleButtonClick() {
      if (this.applicant.applicationStatus === "APPLICATION_WITHDRAWN") {
        this.rescindWithdrawDecision();
      } else {
        this.dialog = true;
      }
    },


    decideButtonText() {
      if (this.applicant.applicationStatus === "APPLICATION_WITHDRAWN") {
        return "Rescind Withdrawal"
      } else {
        return "WithDraw Applicant"
      }
    },

    rescindWithdrawDecision() {
      console.log("I have been clicked")
      if (confirm("Are you sure you want to Rescind withdraw decision of applicant")) {
        const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
        axios.patch(rescindWithdrawApplicant(this.applicantEmail), {},{headers: elderHeader})
            .then(res => {
              alert(res.data.message)
            })
            .catch(err => {
              alert(err.response.data.message)
            })

      }
    },


    withdrawApplicantApplication() {
      const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
      axios.post(withdrawApplicant, {
        applicantEmail: this.applicantEmail,
        reasonForWithdraw: this.reasonForWithdraw

      }, {headers: elderHeader})
          .then(res => {
            console.log(res.data)
            this.dialog=false
            alert(res.data.message)
          })
          .catch(err => {
            alert(err.response.data.message)
          })


    }

  },
  computed: {
    ...mapGetters(['applicantEmail', 'applicant'])
  },

}

</script>

<style scoped>
.comment-heading{
  font-weight: 500!important;
  font-size: 32px !important;
  line-height: 33px!important;
  letter-spacing: -0.02em;
  color: #2B1C1C !important;
  margin-left:-17px;
}

.box{
  box-shadow: none!important;
  cursor: pointer;
}
.comment-content{
  margin-left: 52px;
  margin-right: 52px;
  font-family: IBM Plex Sans !important;
  font-style: normal!important;
  font-weight: normal;

}
.payment-label{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;

  color: #2B1C1C;

}
.submit{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 25px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;

  color: #FFFFFF;


}

.invite{
  font-family: IBM Plex Sans;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  display: flex;
  align-items: center !important;
  letter-spacing: 0.02em;
  color: #FF7E1D;
}
.err {
  color: red !important;
}
.invite-box{
  background: #FFDDD9;
  border-radius: 8px;
  padding: 3px;
}
.actions-btn{
  padding-top: 30px;
  margin-left: 45px;
}
.actions-btn-text{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  color: #2B1C1C;
  text-transform: capitalize!important;
}
.actions-card{
  border-radius: 8px;
  background: #FFF2C7;
  height: 95px;
}
</style>